import { Navigate, useLocation, useParams } from "react-router-dom"
import { legacyBidRedirectTarget, type LegacyBidSection } from "@/lib/bid-sections"

/**
 * A pre-R4 bid path (`/documents`, `/analysis`, `/strategy`, `/go-no-go`,
 * `/responses`, `/submission-pack`, `/chat`). Notification emails, insight
 * cards and bookmarks still point at these, so the redirects are permanent.
 * `replace` keeps the old URL out of history, so Back never loops.
 */
export function LegacyBidRedirect({ from }: { from: LegacyBidSection }) {
  const { bidId } = useParams<{ bidId: string }>()
  const location = useLocation()

  if (!bidId) return <Navigate replace to="/app/bids" />

  const target = legacyBidRedirectTarget(bidId, from, location.search)
  return <Navigate replace to={{ ...target, hash: location.hash }} />
}
